import { render, staticRenderFns } from "./orderAmount.vue?vue&type=template&id=3b20c7fd&scoped=true&"
import script from "./orderAmount.vue?vue&type=script&lang=js&"
export * from "./orderAmount.vue?vue&type=script&lang=js&"
import style0 from "./orderAmount.vue?vue&type=style&index=0&id=3b20c7fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20c7fd",
  null
  
)

export default component.exports